import React, { useEffect, useState } from 'react'
import { Amplify, API, graphqlOperation } from 'aws-amplify'
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import BecomeDriverSection from '../components/UI/BecomeDriverSection';
import driveImg from "../assets/all-images/drive.jpg";
import "../styles/about.css";
import ProductItem from '../components/UI/ProductItem'
import axios from 'axios';
import {listProductCategories} from '../graphql/queries'
import GalleryContent from './GalleryContent';

const listProductCategoryLinks = [{}]

const Gallery = () => {


//     const [listProductCat, setlistProductCat] = useState(listProductCategoryLinks)
  
//     useEffect( () => {
//        // (async () => {
//       fetchTodos()
//        // })
//    }, [])
//     const fetchTodos = async ()=> {
//        try {
//          const listProductCatData = await API.graphql(graphqlOperation(listProductCategories));
// console.log(listProductCatData, "listProductCatData")

//          const _productCategoriesList = listProductCatData?.data?.listProductCategories?.items
//          setlistProductCat(_productCategoriesList)
//        } catch (err) { console.log(err, 'error fetching listMenu') }
//      }

  return (
    <Helmet title="gallery">
      <CommonSection title="Gallery" />
       {/* ===============Productsection=============== */}
     <GalleryContent />

     
     
    </Helmet>
  )
}

export default Gallery
